import { useState, useRef, useCallback, useEffect, useReducer } from 'react';

/**
 * Hook-based wrapper for `setTimeout()`.
 */

function useTimer() {
  var _useState = useState({
    time: null,
    done: false
  }),
      state = _useState[0],
      setState = _useState[1];

  var timerId = useRef(null);
  var start = useCallback(function (ms) {
    setState({
      time: ms,
      done: false
    });
  }, [setState]);
  useEffect(function () {
    if (!timerId.current && state.time) {
      timerId.current = setTimeout(function () {
        setState({
          time: null,
          done: true
        });
        timerId.current = null;
      }, state.time);
    }

    return function () {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
  }, [state, setState]);
  return {
    start: start,
    done: state.done
  };
}

var reducer = function reducer(state, action) {
  var isLoading = action.isLoading,
      timerDone = action.timerDone;

  switch (state) {
    case 'off':
      {
        return isLoading ? 'delayTrigger' : 'off';
      }

    case 'delayTrigger':
      {
        return isLoading ? 'delayWait' : 'off';
      }

    case 'delayWait':
      {
        return isLoading ? timerDone ? 'onTrigger' : 'delayWait' : 'off';
      }

    case 'onTrigger':
      {
        return isLoading ? 'onWait' : 'off';
      }

    case 'onWait':
      {
        return timerDone ? 'on' : 'onWait';
      }

    case 'on':
      {
        return isLoading ? 'on' : 'off';
      }
  }
};
/**
 * Debounces `isLoading` input. If `isLoading` remains `true` for at least `initialDelay` miliseconds, this hook
 * will returns `true` for `minimalTimeOn` miliseconds.
 * @param isLoading - Input signal you wish to debounce (usually it connects to a spinner and indicates a pending operation)
 * @param initialDelay - Delay in miliseconds. Requests shorter than `initialDelay` will be ignored.
 * @param minimalTimeOn - Once spinner appears, it will stay on screen for a least `minimalTimeOn` miliseconds.
 * @returns Debounced `isLoading` signal
 */


function useDebouncedLoader(isLoading, initialDelay, minimalTimeOn) {
  if (initialDelay === void 0) {
    initialDelay = 400;
  }

  if (minimalTimeOn === void 0) {
    minimalTimeOn = 400;
  }

  var _useReducer = useReducer(reducer, 'off'),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var _useTimer = useTimer(),
      start = _useTimer.start,
      done = _useTimer.done;

  useEffect(function () {
    if (state === 'delayTrigger') {
      start(initialDelay);
    } else if (state === 'onTrigger') {
      start(minimalTimeOn);
    }

    dispatch({
      isLoading: isLoading,
      timerDone: done
    });
  }, [state, isLoading, start, done, initialDelay, minimalTimeOn]);
  return state === 'on' || state === 'onWait';
}

export { useDebouncedLoader, useTimer };
//# sourceMappingURL=use-debounced-loader.esm.js.map
